import { HDate, Location } from "@hebcal/core";
import { magvar } from "magvar";
import { createSkyBanner } from './sky-banner.js';
import { jerusalemBearing, jerusalemDistance, magneticDeclination, normalizeAngle, signedAngle } from './heading-state.js';
window.createSiddurSkyBanner = createSkyBanner;
window.SiddurHeadingGeometry = {jerusalemBearing,jerusalemDistance,magneticDeclination,normalizeAngle,signedAngle};
import { CITY_NAMES, getDailyInfo, localizeCoordinates, personalPsalmForBirth, resolveLocation } from "./calendar-logic.js";

window.SiddurCalendar = {
  cityNames: CITY_NAMES,
  cities: CITY_NAMES.map((name) => {
    const loc = resolveLocation({ city: name });
    return loc ? { name, latitude: loc.getLatitude(), longitude: loc.getLongitude(), tzid: loc.getTzid(), il: loc.getIsrael() } : null;
  }).filter(Boolean),
  daily: getDailyInfo,
  resolveLocation: (config) => {
    const loc = resolveLocation(config);
    return { name: loc.getName(), latitude: loc.getLatitude(), longitude: loc.getLongitude(), tzid: loc.getTzid(), il: loc.getIsrael() };
  },
  hdate: (year, month, day) => new HDate(day, month, year).render("en"),
  personalPsalmForBirth,
  localizeCoordinates,
  magneticDeclination: (latitude, longitude, altitude = 0) => magvar(latitude, longitude, altitude),
};
